import { render, staticRenderFns } from "./btnManage.vue?vue&type=template&id=09d84e86&scoped=true&"
import script from "./btnManage.vue?vue&type=script&lang=js&"
export * from "./btnManage.vue?vue&type=script&lang=js&"
import style0 from "./btnManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./btnManage.vue?vue&type=style&index=1&id=09d84e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d84e86",
  null
  
)

export default component.exports